import { Box } from "@mui/material";
import FormAutocompleteMulti from "app/components/form-components/FormAutocompleteMulti";
import FormCountryAutocomplete from "app/components/form-components/FormCountryAutocomplete";
import FormStateAutocomplete from "app/components/form-components/FormStateAutocomplete";
import LocationAutocompleteMulti from "app/components/form-components/LocationAutocompleteMulti";
import { useDebounce } from "app/hooks/useDebounce";
import useGetLocationSuggestion from "app/hooks/useGetLocationSuggestion";
import { Countries } from "app/utils/selection_constants";
import { useEffect, useState } from "react";
import { LocationOptions } from "../../Constants";
function MultiSelectLocation({ control, preloadedData, setValue, watch }) {
  const [options, setOptions] = useState([
    { placeId: "xysaldfj", mainText: "Search cities...", secondaryText: "" }
  ]);
  const [selectedCountries, setSelectedCountry] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [states, setStates] = useState([]);
  const [search, setSearch] = useState();
  const debounceSearch = useDebounce(search, 880);

  const getDefaultCityValues = () => {
    if (!preloadedData?.jp_city) return [];
    return preloadedData.jp_city
      .split("| ")
      .map((city) => (typeof city === "string" ? { placeId: city, mainText: city } : city));
  };

  const { data: suggestions, isLoading } = useGetLocationSuggestion({
    input: debounceSearch,
    select: (data) => [data]
  });

  useEffect(() => {
    if (suggestions) {
      setOptions(suggestions);
    }
  }, [suggestions]);

  useEffect(() => {
    // Set countries from database once
    if (preloadedData?.jp_country) {
      const splitCountries = preloadedData?.jp_country.split("| ");
      const countriesFromDB = Countries.filter((country) =>
        splitCountries.some((value) => country.label === value)
      );
      setSelectedCountry(countriesFromDB);
    }
  }, [setSelectedCountry, preloadedData]);

  return (
    <div>
      <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" gap={2} flexDirection={{ xs: "column", md: "row" }}>
          <FormAutocompleteMulti
            control={control}
            defaultValue={preloadedData ? preloadedData.jp_location : ""}
            name={"jp_location"}
            label={"Location Type *"}
            sxValues={{ width: "100%", flex: 1 }}
            helperText={"Location is required"}
            isOptionEqualToValue={(option, value) => option.label === value.label}
            values={LocationOptions}
          />
          <FormCountryAutocomplete
            control={control}
            name={"jp_country"}
            label={"Country"}
            country={preloadedData?.jp_country}
            selectedCountry={selectedCountries}
            setSelectedCountry={setSelectedCountry}
          />
        </Box>

        <Box display="flex" gap={2} flexDirection={{ xs: "column", md: "row" }}>
          <FormStateAutocomplete
            control={control}
            name={"jp_state"}
            label={"State"}
            selectedCountries={selectedCountries}
            statesFromDB={preloadedData?.jp_state}
            selectedStates={selectedStates}
            setSelectedStates={setSelectedStates}
            states={states}
            setStates={setStates}
            setValue={setValue}
          />
          <LocationAutocompleteMulti
            freeSolo
            multiple
            name={"jp_city"}
            type={"City *"}
            options={options}
            isLoading={isLoading}
            inputLabel={"City *"}
            defaultValue={getDefaultCityValues()}
            control={control}
            handleValueSeleted={(newValues) => {
              if (newValues) {
              }
              return newValues;
            }}
            handleInputChange={(e, newValue, reason) => {
              setSearch(newValue);
              if (reason === "clear") {
                setValue("jp_cities", []);
                setValue("jp_country", "");
                setValue("jp_state", "");
              }
            }}
            setOptions={setOptions}
            rules={{ required: "City is required" }}
          />
        </Box>
      </Box>
    </div>
  );
}

export default MultiSelectLocation;